import { axios } from '@Root/API'

export const create = payload => {
  return axios.post('admin/notification/reset-password-template', payload)
}
